"use strict";
exports.getWeeksInMonth = getWeeksInMonth;
var _index = require("./differenceInCalendarWeeks.js");
var _index2 = require("./lastDayOfMonth.js");
var _index3 = require("./startOfMonth.js");
function getWeeksInMonth(date, options) {
  return (0, _index.differenceInCalendarWeeks)(
    (0, _index2.lastDayOfMonth)(date),
    (0, _index3.startOfMonth)(date),
    options
  ) + 1;
}
